<div style="background-color: #ffffff;" id="clipboardContainer" [innerHtml]="renderedHtml | unsafe: 'html'"></div>
